import { createSelector } from 'reselect';
import name from './name';

export const getSubState = (state) => state[name];

export const getSidebarIsVisible = createSelector(
  [getSubState],
  (state) => state.sideBarIsVisible,
);
